<template lang="pug">
.c-comments__thread
  vue-user-comment(:comment='comment')
  .c-comments__reply
    vue-user-comment(v-for='reply in comment.replies', :comment='reply', :key="reply._id")
    vue-user-comment-form(ref='replyForm', type='reply', v-show='status === "reply"', :placeholder='__("Reply comments...")', :rows='3', :buttons='{submit: {value: __("Reply")}, cancel: {value: __("Cancel")}, login: {value: type === "projects_backer_only" ? __("Post (Backers only)") : __("Log in to Post") }}')
</template>

<script>
const THREADS_STATUS = {
  INIT: 'init',
  REPLY: 'reply'
};

import { userCommentsStore } from '../../stores/UserComments';
import userComment from './userComment.vue';
import userCommentForm from './userCommentForm.vue';
import { I18n } from '../../util/mixin/i18n.mixin';

export default {
  mixins: [I18n],
  components: {
    'vue-user-comment': userComment,
    'vue-user-comment-form': userCommentForm
  },
  props: ['comment', 'type'],

  data() {
    return {
      status: THREADS_STATUS.INIT
    };
  },

  methods: {
    resetStatus() {
      this.status = THREADS_STATUS.INIT;
      // cancel・replyボタンの有無で高さが変化するので親に伝える
      if (window.vueEventBus && window.vueEventBus.userComments) {
        window.vueEventBus.userComments.$emit('CHANGE_HEIGHT');
      }
    }
  },

  created() {
    this.$on('status.reply', (b) => {
      this.status = b ? THREADS_STATUS.REPLY : THREADS_STATUS.INIT;
      this.$nextTick(function () {
        this.$refs.replyForm.focus();
      });
    });

    this.$root.$on('UPDATED', () => {
      this.resetStatus();
      return true;
    });
  },

  mounted() {
    this.$refs.replyForm.$on('cancel', () => {
      this.resetStatus();
    });

    this.$refs.replyForm.$on('submit', () => {
      userCommentsStore.postReply(
        this.comment._id,
        this.$refs.replyForm.comment
      );
    });
  }
};
</script>
